import React from 'react';
import Search from './Search';
import { Container, Row } from 'react-bootstrap';
import { useAuth0 } from '@auth0/auth0-react';
import FAQ from './FAQ';

export default function Home() {
    const { isAuthenticated } = useAuth0();
    return (
        <Container fluid>
            { isAuthenticated ? 
            <Row>
                <Search />
            </Row> 
                : null}
            <Row>                
                <FAQ />
            </Row>
        </Container>
    );
}
